// Static data for 7MED — 2 categorie corsi: aziende | patente — + AED noleggio
import { Building2, Users, Clock3, Award, ShieldCheck, Heart, GraduationCap, Activity, Wrench } from "lucide-react";

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_zealous-goodall-9/artifacts/o7ztlruv_7med.png";

export const COMPANY = {
    name: "7MED",
    legalName: "7MED GROUP",
    phone: "+41 91 261 51 99",
    phoneRaw: "+41912615199",
    email: "backoffice@7med.ch",
    motto: "La formazione che fa la differenza.",
};

export const SEDI = [
    { slug: "mendrisio", city: "Mendrisio", address: "Via Luigi Lavizzari 2", zip: "6850 Mendrisio", cof: "c/o Scuola Guida DueGi", phone: "+41 91 261 51 99", email: "backoffice@7med.ch", mapsQuery: "Via+Luigi+Lavizzari+2,+6850+Mendrisio", primary: true },
    { slug: "savosa", city: "Lugano · Savosa", address: "Via Cantonale 3", zip: "6942 Savosa", cof: "c/o Scuola Guida DueGi", phone: "+41 91 261 51 99", email: "backoffice@7med.ch", mapsQuery: "Via+Cantonale+3,+6942+Savosa" },
    { slug: "bellinzona", city: "Bellinzona", address: "Via San Gottardo 22", zip: "6500 Bellinzona", cof: null, phone: "+41 91 261 51 99", email: "backoffice@7med.ch", mapsQuery: "Via+San+Gottardo+22,+6500+Bellinzona" },
    { slug: "locarno", city: "Locarno", address: "Via ai Saleggi 5", zip: "6600 Locarno", cof: "c/o Scuola Guida Tre", phone: "+41 91 261 51 99", email: "backoffice@7med.ch", mapsQuery: "Via+ai+Saleggi+5,+6600+Locarno" },
];

export const STATS = [
    { value: "15+", label: "Anni di esperienza" },
    { value: "6'500", label: "Persone formate" },
    { value: "300+", label: "Corsi all'anno" },
    { value: "4.9", label: "Punteggio medio" },
];

export const CATEGORIES = {
    aziende: { key: "aziende", label: "Per le aziende", description: "Formazione conforme OLL3 Art. 36 e workshop su misura.", icon: Building2 },
    patente: { key: "patente", label: "Per la patente", description: "Per aspiranti conducenti.", icon: GraduationCap },
};

// ====== TUTTI I CORSI ======
export const COURSES = [
    // ===== AZIENDE =====
    {
        slug: "bls-aed-src",
        category: "aziende",
        audience: "aziende",
        audienceLabel: "Per le aziende",
        audienceDescription: "Obbligatorio OLL3 Art. 36",
        menuIcon: Building2,
        title: "BLS-AED SRC",
        fullTitle: "BLS-AED SRC per Aziende",
        subtitle: "Rianimazione cardiopolmonare e uso del defibrillatore",
        tagline: "Il corso obbligatorio per le aziende svizzere.",
        duration: "3-4 ore",
        groupSize: "5-8 persone",
        certification: "Certificato SRC · valido 2 anni",
        priceNote: "Su preventivo",
        price: null,
        eyebrow: "Obbligo di legge · OLL3 Art. 36",
        bullets: [
            "Conforme alla Legge sul Lavoro (OLL3 Art. 36)",
            "70% pratica su manichini professionali",
            "Certificazione ufficiale Swiss Resuscitation Council",
            "In sede aziendale o presso le nostre 4 sedi",
            "Gruppi da 5 a 8 partecipanti",
        ],
        modules: [
            {
                name: "Organizzazione e sicurezza",
                description: "All'inizio del corso BLS-AED (SRC), viene sottolineata l'importanza del primo soccorso. Come soccorritori, siamo il primo anello della catena della sopravvivenza, che si estende fino al trattamento medico in ospedale. La nostra responsabilità è quella di avviare un'assistenza tempestiva ed efficace per le persone ferite o malate. Per colmare il divario fino all'arrivo dei soccorsi professionali e per garantire la nostra sicurezza, esaminiamo innanzitutto la struttura di una risposta di primo soccorso.",
            },
            {
                name: "Numeri di emergenza e comunicazione",
                description: "In Svizzera, esiste l'obbligo legale di prestare il primo soccorso, a condizione che sia ragionevole farlo in base alle circostanze. In parole povere: siamo tenuti almeno a chiamare i servizi di emergenza. Nei nostri corsi, riceverete una panoramica dei diversi punti di contatto in caso di emergenza e imparerete come sono strutturati. Ci concentriamo anche sull'interazione con le persone colpite e sugli aspetti specifici da considerare quando si comunica con altri soccorritori o servizi di soccorso.",
            },
            {
                name: "Valutazione della condizione del paziente",
                description: "Alcuni lo conoscono come Schema ORA, altri come schema ABCDE. Noi preferiamo un approccio pragmatico e ci concentriamo su due semplici domande fondamentali per determinare le condizioni del paziente:\n• La persona interessata è reattiva?\n• La persona interessata respira normalmente?\nLe risposte a queste domande ci guideranno verso le misure appropriate.",
            },
            {
                name: "Posizione laterale di sicurezza",
                practical: true,
                description: "La posizione di sicurezza è fondamentale per mantenere aperte le vie aeree e consentire il drenaggio dei liquidi corporei. Nei nostri corsi imparerai come e quando applicare correttamente la posizione di sicurezza.",
            },
            {
                name: "BLS-AED · Misure immediate salvavita",
                practical: true,
                description: "Questo punto costituisce il fulcro del corso BLS-AED: le compressioni toraciche e l'uso del defibrillatore semiautomatico esterno (AED). In caso di arresto cardiaco, un primo soccorso immediato e correttamente eseguito può salvare la vita!\n\nUtilizzando i manichini per la rianimazione che forniamo, impareremo come eseguire le compressioni toraciche e applicare la corretta tecnica di respirazione artificiale come soccorritori, da soli o in team.\n\nSe durante la rianimazione sono presenti più soccorritori, è necessario utilizzare un defibrillatore, se disponibile. Esamineremo il funzionamento esatto di questo dispositivo e spiegheremo come somministrare in sicurezza una scarica elettrica salvavita attraverso un utilizzo corretto.",
            },
            {
                name: "Sessione finale e certificazione",
                description: "Diamo grande importanza all'interattività nei nostri corsi e pertanto incoraggiamo i partecipanti a porre domande in qualsiasi momento. Apprezziamo molto anche il vostro feedback sui nostri corsi, poiché ci aiuta a svilupparli e migliorarli costantemente.\n\nI nostri corsi BLS-AED (SRC) si concludono con una sessione di domande e risposte e il rilascio del certificato ufficiale.",
            },
        ],
        ctaType: "quote",
        href: "/corsi/bls-aed-src",
        faq: [
            { q: "Il corso BLS-AED è obbligatorio in Ticino?", a: "Sì. L'OLL3 Art. 36 (Ordinanza 3 sulla protezione della salute) impone al datore di lavoro di garantire personale formato per il primo soccorso. Il certificato SRC BLS-AED è lo standard riconosciuto in tutta la Svizzera." },
            { q: "Quanto dura la validità del certificato BLS-AED SRC?", a: "Il certificato Swiss Resuscitation Council è valido 2 anni. Dopo questo periodo è necessario ripetere il corso per mantenere la certificazione attiva." },
            { q: "Possiamo fare il corso direttamente in azienda?", a: "Sì. Veniamo presso la vostra sede con manichini e defibrillatori da training. In alternativa potete usare le nostre 4 sedi in Ticino: Mendrisio, Lugano-Savosa, Bellinzona, Locarno." },
            { q: "Quanti dipendenti devono essere formati?", a: "L'OLL3 raccomanda almeno un addetto per turno e area di lavoro, ma il numero esatto non è fisso: dipende dal profilo di rischio specifico della vostra azienda. Offriamo una consulenza gratuita per valutare la vostra realtà e calcolare correttamente il numero di persone da formare." },
        ],
    },
    {
        slug: "bls-aed-misv",
        category: "aziende",
        audience: "aziende",
        audienceLabel: "Per le aziende",
        audienceDescription: "BLS-AED + Misure Salvavita Immediate (MISV)",
        menuIcon: ShieldCheck,
        title: "BLS-AED SRC + MISV",
        fullTitle: "BLS-AED SRC + MISV",
        subtitle: "Corso completo SRC con Misure Salvavita Immediate",
        tagline: "BLS-AED + manovre salvavita complete in un unico corso.",
        duration: "6-7 ore",
        groupSize: "6-12 persone",
        certification: "Certificato SRC BLS-AED · MISV · valido 2 anni",
        priceNote: "Su preventivo",
        price: null,
        eyebrow: "Formazione completa · SRC + MISV",
        bullets: [
            "Include BLS-AED SRC + tutte le Misure Salvavita Immediate",
            "Disostruzione vie aeree (Heimlich), emorragie, ustioni, traumi",
            "Posizione laterale di sicurezza, gestione shock, ferite",
            "Più completo del solo BLS-AED, ideale per soccorritori designati",
            "Conforme OLL3 Art. 36 · SECO · Swiss Resuscitation Council",
        ],
        modules: [
            {
                name: "Organizzazione e sicurezza",
                description: "All'inizio del corso BLS-AED (SRC), viene sottolineata l'importanza del primo soccorso. Come soccorritori, siamo il primo anello della catena della sopravvivenza, che si estende fino al trattamento medico in ospedale. La nostra responsabilità è quella di avviare un'assistenza tempestiva ed efficace per le persone ferite o malate. Per colmare il divario fino all'arrivo dei soccorsi professionali e per garantire la nostra sicurezza, esaminiamo innanzitutto la struttura di una risposta di primo soccorso.",
            },
            {
                name: "Numeri di emergenza e comunicazione",
                description: "In Svizzera, esiste l'obbligo legale di prestare il primo soccorso, a condizione che sia ragionevole farlo in base alle circostanze. In parole povere: siamo tenuti almeno a chiamare i servizi di emergenza. Nei nostri corsi, riceverete una panoramica dei diversi punti di contatto in caso di emergenza e imparerete come sono strutturati. Ci concentriamo anche sull'interazione con le persone colpite e sugli aspetti specifici da considerare quando si comunica con altri soccorritori o servizi di soccorso.",
            },
            {
                name: "Valutazione della condizione del paziente",
                description: "Alcuni lo conoscono come Schema ORA, altri come schema ABCDE. Noi preferiamo un approccio pragmatico e ci concentriamo su due semplici domande fondamentali per determinare le condizioni del paziente:\n• La persona interessata è reattiva?\n• La persona interessata respira normalmente?\nLe risposte a queste domande ci guideranno verso le misure appropriate.",
            },
            {
                name: "Posizione laterale di sicurezza",
                practical: true,
                description: "La posizione di sicurezza è fondamentale per mantenere aperte le vie aeree e consentire il drenaggio dei liquidi corporei. Nei nostri corsi imparerai come e quando applicare correttamente la posizione di sicurezza.",
            },
            {
                name: "BLS-AED",
                practical: true,
                description: "Questo punto costituisce il fulcro del corso BLS-AED: le compressioni toraciche e l'uso del defibrillatore semiautomatico esterno (AED). In caso di arresto cardiaco, un primo soccorso immediato e correttamente eseguito può salvare la vita!\n\nUtilizzando i manichini per la rianimazione che forniamo, impareremo come eseguire le compressioni toraciche e applicare la corretta tecnica di respirazione artificiale come soccorritori, da soli o in team.\n\nSe durante la rianimazione sono presenti più soccorritori, è necessario utilizzare un defibrillatore, se disponibile. Esamineremo il funzionamento esatto di questo dispositivo e spiegheremo come somministrare in sicurezza una scarica elettrica salvavita attraverso un utilizzo corretto.",
            },
            {
                name: "Trattamento di Ferite e Ustioni",
                description: "Questo modulo fornisce le competenze tecniche necessarie per identificare e gestire con efficacia le diverse lesioni dei tessuti. Il programma approfondisce il riconoscimento clinico delle ferite da taglio e la classificazione dei vari gradi di ustione, offrendo una guida pratica all'applicazione di tecniche di medicazione avanzate per ottimizzare i tempi di guarigione e prevenire complicazioni.",
            },
            {
                name: "Sicurezza e Soccorso Stradale",
                description: "Un percorso focalizzato sull'analisi e l'intervento in contesti incidentali sulla pubblica via. I partecipanti impareranno a valutare i pericoli ambientali per operare in totale sicurezza, proteggendo se stessi e gli altri. Verranno inoltre illustrate e provate le manovre corrette per l'estrazione in sicurezza di un paziente da un veicolo, bilanciando tempestività e tutela della colonna vertebrale.",
            },
            {
                name: "Sessione finale e certificazione",
                description: "Diamo grande importanza all'interattività nei nostri corsi e pertanto incoraggiamo i partecipanti a porre domande in qualsiasi momento. Apprezziamo molto anche il vostro feedback sui nostri corsi, poiché ci aiuta a svilupparli e migliorarli costantemente.\n\nI nostri corsi BLS-AED SRC + MISV si concludono con una sessione di domande e risposte e il rilascio del certificato ufficiale.",
            },
        ],
        ctaType: "quote",
        href: "/corsi/bls-aed-misv",
        faq: [
            { q: "Il corso BLS-AED SRC + MISV è obbligatorio in Ticino?", a: "Per ottemperare alla Legge sul Lavoro (OLL3 Art. 36) è sufficiente la parte BLS-AED SRC: è quella che garantisce la conformità normativa. La parte MISV (Misure Salvavita Immediate) è un'integrazione completa molto consigliata, ma non obbligatoria per legge. Molte aziende la scelgono per dare ai propri soccorritori una preparazione più ampia su ferite, emorragie, ustioni, traumi e shock." },
            { q: "Quanto dura la validità del certificato BLS-AED SRC?", a: "Il certificato Swiss Resuscitation Council è valido 2 anni. Dopo questo periodo è necessario ripetere il corso per mantenere la certificazione attiva." },
            { q: "Possiamo fare il corso direttamente in azienda?", a: "Sì. Veniamo presso la vostra sede con manichini e defibrillatori da training. In alternativa potete usare le nostre 4 sedi in Ticino: Mendrisio, Lugano-Savosa, Bellinzona, Locarno." },
            { q: "Quanti dipendenti devono essere formati?", a: "L'OLL3 raccomanda almeno un addetto per turno e area di lavoro, ma il numero esatto non è fisso: dipende dal profilo di rischio specifico della vostra azienda. Offriamo una consulenza gratuita per valutare la vostra realtà e calcolare correttamente il numero di persone da formare." },
        ],
    },
    {
        slug: "workshop-aziendali",
        category: "aziende",
        audience: "aziende",
        audienceLabel: "Per le aziende",
        audienceDescription: "Sessioni personalizzate da 30 minuti",
        menuIcon: Users,
        title: "Workshop Aziendali",
        fullTitle: "Workshop Aziendali su Misura",
        subtitle: "Sessioni personalizzate, da 30 minuti in su",
        tagline: "Formazione modulabile per Safety Day, team building e refresh.",
        duration: "Da 30 min · personalizzabile",
        groupSize: "Flessibile · su richiesta",
        certification: "Attestato di partecipazione",
        priceNote: "Su misura",
        price: null,
        eyebrow: "Su misura · in sede",
        bullets: [
            "Programma costruito sulle vostre esigenze specifiche",
            "Ideale per Safety Day, team building, refresh certificazioni",
            "Temi: BLS, ferite, ustioni, soffocamento, defibrillatore",
            "Modulabile da 30 min a giornata intera",
            "Materiale didattico personalizzato con il vostro logo",
        ],
        format: {
            intro: "I workshop non hanno un programma fisso: servono a dare le nozioni base di primo soccorso in poco tempo, con un format completamente modulabile. Decidiamo insieme durata, temi e ritmo in base alla giornata che avete in mente.",
            stats: [
                { label: "Durata sessione", value: "30 min – 2h" },
                { label: "Persone formate al giorno", value: "Fino a 160" },
            ],
            upgradeNote: {
                text: "Hai bisogno di una sessione più lunga di 2 ore?",
                linkText: "Scopri il corso BLS-AED SRC",
                linkHref: "/corsi/bls-aed-src",
            },
            features: [
                "Sessioni multiple in parallelo o a rotazione",
                "Temi scelti da voi: BLS, ferite, soffocamento, AED, ecc.",
                "Ideale per Safety Day, team building o eventi aziendali",
                "Materiale didattico personalizzabile col vostro logo",
                "Attestato di partecipazione per ogni partecipante",
            ],
        },
        modules: [],
        ctaType: "quote",
        href: "/corsi/workshop-aziendali",
    },
    // ===== PATENTE =====
    {
        slug: "samaritani",
        category: "patente",
        audience: "privati",
        audienceLabel: "Per la patente",
        audienceDescription: "Corso 10h per la patente di guida",
        menuIcon: GraduationCap,
        title: "Corso Samaritani",
        fullTitle: "Corso Samaritani · Soccorritori",
        subtitle: "Anche detto Corso Soccorritori — obbligatorio per la licenza di condurre",
        tagline: "10 ore su due giornate per ottenere la licenza di condurre.",
        duration: "10 ore · 2 giornate",
        groupSize: "Massimo 12 persone",
        certification: "Attestato ufficiale riconosciuto USTRA",
        priceNote: "CHF 140",
        price: "CHF 140",
        eyebrow: "Patente · Obbligatorio",
        bullets: [
            "Riconosciuto ufficialmente per la licenza di condurre",
            "Teoria + pratica con istruttori certificati USTRA",
            "Manovre salvavita di base (BLS, posizione laterale)",
            "Attestato rilasciato al termine del corso",
            "Massimo 12 partecipanti per apprendimento efficace",
        ],
        info: [
            { label: "Bonus inclusi", value: "Al termine del corso ricevi i buoni omaggio per continuare la formazione con le nostre autoscuole partner e per la visita oculistica gratuita. Tutto incluso nel prezzo del corso." },
            { label: "Durata", value: "10 ore di formazione distribuite su 2 giornate, per un apprendimento graduale ed efficace." },
            { label: "Gruppi", value: "Massimo 12 persone per sessione. Lezioni teoriche e tante esercitazioni pratiche." },
        ],
        topicsIntro: "Apprenderai le competenze essenziali per intervenire in caso di emergenza stradale.",
        topics: [
            "Valutazione della situazione e sicurezza",
            "Numeri di emergenza e allarme corretto",
            "Valutazione del paziente",
            "Arresto cardiaco e rianimazione (BLS-AED)",
            "Posizione laterale di sicurezza",
            "Gestione traumi e ferite",
            "Comportamento sulla scena dell'incidente",
            "Estrazione sicura del paziente dal veicolo",
        ],
        groupNote: {
            title: "Vuoi un corso privato o per il tuo gruppo?",
            text: "Organizziamo sessioni dedicate su richiesta. Minimo 8 partecipanti, massimo 12. Su richiesta possiamo anche venire presso la vostra sede o struttura. Scrivici o chiamaci per concordare data, location e dettagli.",
        },
        venueOnSite: false,
        modules: [],
        ctaType: "enroll",
        href: "/corsi/samaritani",
        bookingOrgSlug: "duegi",
        bookingOrgSlugs: ["duegi", "7med"],
        bookingTipoNomeIncludes: "samaritan",
        faq: [
            { q: "Il Corso Samaritani è obbligatorio per la patente?", a: "Sì. È obbligatorio per ottenere la prima licenza di condurre svizzera (categoria B e altre). È riconosciuto ufficialmente da USTRA." },
            { q: "Quanto costa il Corso Samaritani in Ticino?", a: "CHF 140 tutto incluso: 10 ore di formazione, materiali didattici, attestato finale riconosciuto USTRA." },
            { q: "Quanto dura la validità dell'attestato?", a: "L'attestato Samaritani per la patente è valido 6 anni dalla data di rilascio. Dopo l'ottenimento della licenza non scade." },
            { q: "Dove si svolge il corso?", a: "Nelle 4 sedi 7MED in Ticino: Mendrisio, Lugano-Savosa, Bellinzona, Locarno. Date e disponibilità sul calendario." },
        ],
    },
];

export const getCourse = (slug) => COURSES.find((c) => c.slug === slug);
export const coursesByCategory = (cat) => COURSES.filter((c) => c.category === cat);

// ====== TEAM, VALUES, CERTIFICATIONS ======
export const TEAM = [
    { name: "Naike Romeo", role: "CEO · Responsabile Formazione", bio: "Guida il team con passione e professionalità. Esperto in formazione sanitaria.", email: "naike@7med.ch", image: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69554edc1dd562cd7eb4fb6d/80e057aee_naike_quadrato.png" },
    { name: "Sara Benevento", role: "Formatrice SRC / USTRA", bio: "Esperta in formazione certificata di primo soccorso e BLS-AED.", email: "sara@7med.ch", image: null },
    { name: "Erika Pagani", role: "Formatrice SRC / USTRA", bio: "Esperta in formazione certificata di primo soccorso e BLS-AED.", image: null },
    { name: "Lorenzo Cairoli", role: "Formatore SRC / USTRA", bio: "Specialista in primo soccorso e gestione delle emergenze.", image: null },
];

export const CLIENTS = ["Repubblica e Cantone Ticino", "Jabil", "Ferrari Industria", "Autolinea Mendrisiense", "Scuola Guida DueGi", "Scuola Guida XDrive", "Scuola Guida Tre"];

export const VALUES = [
    { icon: Heart, title: "Passione", text: "La formazione salvavita è la nostra missione. Ogni corso è un'opportunità per fare la differenza." },
    { icon: Award, title: "Eccellenza", text: "Standard elevati, istruttori certificati SRC/USTRA, materiali sempre aggiornati." },
    { icon: Users, title: "Persone", text: "Gruppi piccoli, attenzione personalizzata, apprendimento efficace." },
    { icon: ShieldCheck, title: "Affidabilità", text: "Certificazioni riconosciute, conformi alle normative svizzere." },
];

export const CERTIFICATIONS = [
    "Centro formazione certificato SRC",
    "Conforme normative legge sul lavoro OLL3",
    "Docenti abilitati USTRA",
    "Corsi certificati EduQua",
];

export const FAQ_HOME = [
    { q: "Il corso BLS-AED è obbligatorio per le aziende?", a: "Sì. L'OLL3 Art. 36 stabilisce che il datore di lavoro deve garantire personale formato per il primo soccorso sul posto di lavoro. Il certificato SRC BLS-AED soddisfa questo requisito." },
    { q: "Qual è la differenza tra BLS-AED e BLS-AED + MISV?", a: "Il BLS-AED SRC copre rianimazione e defibrillazione (3-4h). Il BLS-AED + MISV (6-7h) aggiunge le Misure Salvavita Immediate: disostruzione vie aeree, emorragie, ferite, ustioni, traumi e shock. È la formazione completa." },
    { q: "Cos'è il Corso Samaritani?", a: "È il corso di primo soccorso da 10 ore obbligatorio per ottenere la licenza di condurre svizzera. Anche detto Corso Soccorritori. CHF 140 tutto incluso." },
    { q: "Noleggio defibrillatori: come funziona?", a: "Forniamo AED in noleggio con contratto mensile o annuale: consegna, installazione, formazione base, manutenzione programmata e sostituzione consumabili inclusi. Nessun acquisto iniziale." },
    { q: "Possiamo svolgere il corso in azienda?", a: "Assolutamente. Veniamo presso la vostra sede in tutto il Ticino, e su richiesta anche in Svizzera tedesca e romanda." },
];

// Hero & section images (provided by client)
export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_zealous-goodall-9/artifacts/3l0f3p4p_shutterstock_1850689243.jpg";
export const AED_IMAGE = "https://customer-assets.emergentagent.com/job_zealous-goodall-9/artifacts/3ncdwew1_shutterstock_2574472219.jpg";

// Default images per course — usa HERO_IMAGE (training reale) come default per coerenza
export const COURSE_IMAGES = {
    "bls-aed-src": HERO_IMAGE,
    "bls-aed-misv": HERO_IMAGE,
    "workshop-aziendali": HERO_IMAGE,
    "samaritani": HERO_IMAGE,
};

export const ICONS = { Building2, Users, Clock3, Award, ShieldCheck, Heart, GraduationCap, Activity, Wrench };
